import { fallbackFemale, fallbackMale, fallbackNeutral, fallbackCompany, fallbackTopic, fallbackGroups, } from './fallbacks';
export const getSources = (type) => {
    switch (type) {
        case 'company':
            return { typeImg: fallbackCompany };
        case 'groups':
            return { typeImg: fallbackGroups };
        case 'topic':
            return { typeImg: fallbackTopic };
        case 'female-user':
            return { typeImg: fallbackFemale };
        case 'male-user':
            return { typeImg: fallbackMale };
        case 'neutral-user':
            return { typeImg: fallbackNeutral };
        default:
            return { typeImg: fallbackNeutral };
    }
};
//# sourceMappingURL=get-sources.js.map